import { AbstractChart } from './abstract_chart';

class TimeSeriesChart extends AbstractChart {

	constructor(element) {
		super(element, 'line');
		this.options.scales.x.type = 'time';
	}
}

const time_series = (element) => {
	return new TimeSeriesChart(element);
};


export {
	time_series
}
